import { GetInTouchProps } from './get-in-touch.props';
import React from 'react';
import { Link } from 'react-scroll';

export const GetInTouchMolecule = (props: GetInTouchProps) => {
  return (
    <div
      className={`w-full flex flex-col items-center lg:items-start ${props.addClass}`}
    >
      <Link
        activeClass="active"
        className="button btn-cta block w-full lg:w-52 mx-auto font-waldo-header font-light"
        to="contactUsForm"
        spy={true}
        smooth={true}
        offset={100}
        duration={500}
      >
        {props.label}
      </Link>
    </div>
  );
};
